export default "__VITE_ASSET__DSSRCUAS__"